

import {View} from 'backbone'
import template from 'dashboard/connections/action-operations-view.ejs';
import constants from 'Constants.js';
import ConfirmationModal from 'dashboard/forms/modal/ConfirmationModal';
import {Model} from 'backbone';
import eventBus from 'EventBus';

class ActionOperationsView extends View{
    initialize(opts){
        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            'click input[name=applyChanges]': 'applyChanges',
            'click input[name=cancelChanges]': 'cancelChanges',
            'click input[name=delete]': 'deleteAction',
            'click input[name=test]': 'testAction',
            'click input[name=back]': 'moveBackToConnection'
        };


        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    applyChanges() {
        let actionModel = this.actionService.model.get('currentActionDetails');
        let containInvalidPermissions = false;

        if (actionModel.PermissionsXML) {
            let permissionsArray = Array.isArray(actionModel.PermissionsXML) ? actionModel.PermissionsXML : [actionModel.PermissionsXML];
            const invalidPermissions = permissionsArray.filter(conn => { return !conn.Permission || conn.Permission.length === 0; });
            containInvalidPermissions = invalidPermissions && invalidPermissions.length > 0;

            if (containInvalidPermissions) {
                const
                    confirmationTitle = 'Permission Warning',
                    confirmationText =
                        '<div class="row">' +
                        '  <div class="col-sm-1"><i class="pf-warning"></i></div>' +
                        '  <div class="col-sm-11">' +
                        '    <p> At least one of your users, positions or user-groups has no permission selected. ' +
                        'Applying changes will remove that role.</p>' +
                        '    <p>Are you sure you want to apply changes?</p>' +
                        '  </div>' +
                        '</div>';

                new ConfirmationModal({
                    model: new Model({
                        confirmationTitle: confirmationTitle,
                        confirmationText: confirmationText,
                        height: 220,
                        width: 500
                    })
                }).render().then(result => {
                    if (result === 'Yes') {
                        //remove invalid permissions
                        actionModel.PermissionsXML = permissionsArray.filter(act => { return act.Permission && (($.isArray(act.Permission) && act.Permission.length > 0) || act.Permission['@type']); });
                        this.actionService.model.set('currentActionDetails', actionModel, { silent: true });
                        return this.actionService.applyChanges.apply(this.actionService, arguments);
                    }
                });
            }
        }
        
        if(!containInvalidPermissions){
            return this.actionService.applyChanges.apply(this.actionService, arguments);
        }

        return;
    }

    cancelChanges() {
        return this.actionService.cancelChanges.apply(this.actionService, arguments);
    }

    deleteAction(){
        return this.actionService.deleteAction.apply(this.actionService, arguments);
    }

    moveBackToConnection(){
        const connType = this.model.get("currentActionDetails").Type.slice(0,-1); 
        eventBus.trigger(constants.EV_REFRESH_CONNECTION_DETAILS, this.model.get('connectionId'),connType);
    }

    testAction(){
        return this.actionService.testAction.apply(this.actionService, arguments);
    }

    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }
}

export default ActionOperationsView;